import { createSlice } from "@reduxjs/toolkit";

const loginSlice = createSlice({
    name: 'login',
    initialState: { isLogin: false, user: {},enterprise:{}},
    reducers: {
        setLogin(state, action) {
            state.isLogin = true;
        },
        setEvalue(state,action){
            state.enterprise=action.payload
           
        },
        setLogout(state, action) {
           
            state.isLogin = false;
        },
        setUser(state, action) {
            state.user = action.payload;
        }

    },
});

export const loginActions = loginSlice.actions;

export default loginSlice;
